// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Point-module--cls1--2ExQH","cls2":"styles-Point-module--cls2--131Qm styles-Point-module--cls1--2ExQH","isActive":"styles-Point-module--isActive--1kamd"};